module.exports = "https://p.cds.unp.clasificados.pe/payment-success-property.090f9e966fcf2de17e035b3dfcc8b3e8.png";